const silhouetteAliases: ReadonlyMap<string, string> = new Map(
  Object.entries({
    "albert-park": "melbourne-2",
    shanghai: "shanghai-1",
    suzuka: "suzuka-2",
    miami: "miami-1",
    villeneuve: "montreal-6",
    monaco: "monaco-6",
    catalunya: "catalunya-6",
    "red-bull-ring": "spielberg-3",
    silverstone: "silverstone-8",
    spa: "spa-francorchamps-4",
    hungaroring: "hungaroring-3",
    zandvoort: "zandvoort-5",
    monza: "monza-7",
    madring: "madring-1",
    baku: "baku-1",
    sepang: "sepang-1",
    "marina-bay": "marina-bay-4",
    americas: "austin-1",
    rodriguez: "mexico-city-3",
    interlagos: "interlagos-2",
    vegas: "las-vegas-1",
    losail: "lusail-1",
    "yas-marina": "yas-marina-2",
    "circuit-ceramique": "circuit-ceramique",
  }),
);

export function circuitSilhouetteUrl(circuitId: string): string | null {
  const name = silhouetteAliases.get(circuitId);
  return name === undefined ? null : `/circuit-silhouettes/${name}.svg`;
}

export const circuitSilhouetteAttribution =
  "Circuit silhouettes: Jules Roy, CC BY 4.0";
